// 获取用户信息
export default () => {
  let dfUrl = encodeURIComponent(`${location.href}`)
  // let appid = 'wxc3b759ab9138c5f1' // 活动帮平台公众号
  // location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${dfUrl}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`
  let appid = 'wx494dcfe01adce088' // 飞利浦健康生活
  location.href = `https://wechatb2c.philips.com.cn/api/TokenApi/snsapi_base?returnurl=${dfUrl}&appid=${appid}`
}



// WEBPACK FOOTER //
// ./src/assets/js/auth.js